import utils from '../../utils/tag-name';
import type { IconNames } from '../icon/icon.types';

const TAG_NAME = utils.constructTagName('combobox');

const ICON_NAME = {
  ARROW_UP: 'arrow-up-bold' as Extract<IconNames, 'arrow-up-bold'>,
  ARROW_DOWN: 'arrow-down-bold' as Extract<IconNames, 'arrow-down-bold'>,
} as const;

const FILTER = {
  MATCH_STARTS_WITH: 'match-starts-with',
  NONE: 'none',
} as const;

const AUTOCOMPLETE_LIST = 'list';
const LISTBOX_ID = 'combobox-listbox-id';
const TRIGGER_ID = 'combobox-trigger-id';

export { TAG_NAME, ICON_NAME, FILTER, TRIGGER_ID, LISTBOX_ID, AUTOCOMPLETE_LIST };
